import _get from "lodash/get";
import _findKey from "lodash/findKey";
import _find from "lodash/find";
import { createSelector } from 'reselect';
import { FlowStoppedReason } from "../constants";
export var getActiveFlowState = function getActiveFlowState(state) {
  return _find(state.identity.flows, 'isActive');
};
export var getActiveFlowId = function getActiveFlowId(state) {
  return _findKey(state.identity.flows, 'isActive');
};
export var getFlowStateById = function getFlowStateById(state, id) {
  return _get(state, 'identity.flows', {})[id];
};
export var getFlowStoppedReason = function getFlowStoppedReason(state, id) {
  return _get(state, "identity.flows.".concat(id, ".stoppedReason"));
};
export var getHasFlowCompleted = function getHasFlowCompleted(state, id) {
  return getFlowStoppedReason(state, id) === FlowStoppedReason.COMPLETE;
};
export var getHasFlowClosed = function getHasFlowClosed(state, id) {
  return getFlowStoppedReason(state, id) === FlowStoppedReason.CLOSED;
};
export var getCurrentStepByFlowId = function getCurrentStepByFlowId(state, id) {
  var flowState = getFlowStateById(state, id);
  return _get(flowState, 'step');
};
export var getActiveFlowStep = function getActiveFlowStep(state) {
  var flowId = getActiveFlowId(state);
  return getCurrentStepByFlowId(state, flowId);
};
export var getActiveFlowConfig = createSelector([getActiveFlowState], function (activeFlowState) {
  return _get(activeFlowState, 'config');
});
export var getDataFromFlowState = function getDataFromFlowState(flowState) {
  return _get(flowState, 'data', {});
};